import { render, staticRenderFns } from "./ListSlag.vue?vue&type=template&id=b258586a&scoped=true"
import script from "./ListSlag.vue?vue&type=script&lang=js"
export * from "./ListSlag.vue?vue&type=script&lang=js"
import style0 from "./ListSlag.vue?vue&type=style&index=0&id=b258586a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b258586a",
  null
  
)

export default component.exports